export default __webpack_public_path__ + "static/media/form-sep.73dc28d9.svg";